import { useEffect, useState } from 'react';

const KEY = 'sfp.sidebarCollapsed.v1';

/**
 * Sidebar open/closed state, persisted in localStorage so it survives reloads.
 */
export function useSidebarCollapsed(): [boolean, (b: boolean) => void] {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(KEY) === '1';
    } catch {
      return false;
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(KEY, collapsed ? '1' : '0');
    } catch {
      /* ignore */
    }
  }, [collapsed]);
  return [collapsed, setCollapsed];
}
